// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"PK-z","carouselContainer":"QK-z"};